import * as _ from 'lodash';
import { TaskForm } from '../../../models/task-form';
import {
  addTaskformFailedAction,
  addTaskformStartAction,
  addTaskformSucceededAction,
  removeTaskFormSucceededAction,
  updateTaskFormFieldFailedAction,
  updateTaskFormFieldStartAction,
  updateTaskFormFieldSucceedAction
} from '../action/task-form.action';
import { createReducer, on } from '@ngrx/store';

export interface TaskFormState {
  datas: TaskForm;
  loading: boolean;
  update: boolean;
  error: any;
}

export const TASK_FORM_INITIAL_STATE: TaskFormState = {
  datas: null,
  loading: false,
  update: false,
  error: null,
};




export const taskFormReducer= createReducer(
    TASK_FORM_INITIAL_STATE,
    on(addTaskformStartAction, (state) => {
      return {
        ...state,
        loading: true,
        update:false,
        error: null,
      }
    }) ,
    on(updateTaskFormFieldStartAction, (state) => {
      return {
        ...state,
        loading: true,
        update:true,
        error: null,
      }
    }) ,
    on(addTaskformSucceededAction, (state, {payload}) => {
      return {
        ...state,
        datas: payload,
        loading: false,
        update:false,
        error: null,
      }
    }) ,
    on(updateTaskFormFieldSucceedAction, (state, {payload}) => {
      const datasCopy = _.cloneDeep(state.datas);

      datasCopy.fields = datasCopy.fields.map( (datasCopyField) => {
          if (datasCopyField.id === payload.id ) {
            return payload; // remplacement
          } else {
            return datasCopyField;
          }
       } );
      return {
        ...state,
        datas: datasCopy,
        loading: false,
        update:true,
        error: null,
      }
    }) ,
    on(updateTaskFormFieldFailedAction, (state, {error}) => {
        return {
          ...state,
          loading: false,
          update:true,
          error: error,
        }
    }),
    on(addTaskformFailedAction,  (state, {error}) => {
        return {
          ...state,
          loading: false,
          update:false,
          error: error,
        }
    }),
    on(removeTaskFormSucceededAction,     (state) => {
      return {
        ...state,
        datas: null,
        loading: false,
        update:false,
        error: null,
      }
    })
);
